import React from 'react'
import Withdrawal from '@commons/withdraw'

const Request = () => {
  return (
    <>
      <br />
      <Withdrawal status={'Pending'} />
    </>
  )
}

export default Request
